// @flow

import VideoLayout from 'util/UI/videolayout/VideoLayout';
import { StateListenerRegistry } from '../base/redux';
import { getVideoTrackByParticipant } from '../base/tracks/functions';

import { getLargeVideoParticipant } from './functions';

/**
 * Updates the on stage participant video.
 */
StateListenerRegistry.register(
  /* selector */ (state) => state['features/large-video'].participantId,
  /* listener */ (participantId) => {
    VideoLayout.updateLargeVideo(participantId, true);
  }
);

/**
 * Notifies when the local audio mute state changes.
 */
StateListenerRegistry.register(
  /* selector */ (state) => state['features/large-video'].blurContentWarning,
  /* listener */ (blurContentWarning, store, previousBlurContentWarning) => {
    if (typeof APP !== 'object') {
      return;
    }

    if (blurContentWarning !== previousBlurContentWarning) {
      // eslint-disable-next-line no-undef
      APP.API.notifyCensorStatusChanged(blurContentWarning !== undefined);
    }
  }
);

/**
 * Schedules a large video update when the streaming status of the track associated with the large video changes.
 */
StateListenerRegistry.register(
  /* selector */ (state) => {
    const largeVideoParticipant = getLargeVideoParticipant(state);
    const videoTrack = getVideoTrackByParticipant(state, largeVideoParticipant);

    return {
      participantId: largeVideoParticipant?.id,
      streamingStatus: videoTrack?.streamingStatus
    };
  },
  /* listener */ ({ participantId, streamingStatus }, previousState = {}) => {
    if (streamingStatus !== previousState.streamingStatus) {
      VideoLayout.updateLargeVideo(participantId, true);
    }
  },
  {
    deepEquals: true
  }
);
